import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { useInvAF, useInvMain } from "../../../St/Reviews/UseStyle";
import { useBody, useHeader } from "../invCompany/style";
import { useStylesTF } from "../../../St/Reports/UseStyle";
import { QRCodeCanvas } from "qrcode.react";
import ButtonBase from "@material-ui/core/ButtonBase";

function FooterNotes(props) {
    const { inv, locInv, found } = props;
    const locDinv = JSON.parse(localStorage.getItem("datainv")) || {};
    const clas = useInvAF();
    const classHeader = useHeader();

    const clasm = useInvMain();
    const clasTF = useStylesTF();

    const styfC = { fontSize: "1rem", textAlign: "center", fontWeight: "bold", fontFamily: "Amiri-Regular", paddingBottom: "0.3rem" };
    return (
        <Grid item container
            style={{ padding: 5, fontWeight: "bold", fontFamily: "Amiri-Regular", marginLeft: "0cm" }}
        >
            <Grid
                item
                container
                xs={12}
                style={{ fontWeight: "bold", }}
            >
                <Grid item xs={12} container  >

                    <Grid
                        item
                        xs={12}
                        style={{
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'break-word',
                            fontWeight: "bold",
                            direction: "rtl",
                            fontFamily: "Amiri-Regular",
                            textAlign: "right"
                        }}
                    >
                        {inv.notes}
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'break-word',
                            fontWeight: "bold",
                            direction: "rtl",
                            fontFamily: "Amiri-Regular",
                            textAlign: "right"
                        }}
                    >
                        {found.BillNotes}

                    </Grid>

                    <Grid item xs={4} style={{ textAlign: "reft", fontFamily: "Amiri-Regular", direction: "ltr" }}  >
                        <br />
                        <br />
                        <Grid item xs={12} >
                            <div style={styfC} > {"توقيع المستلم"}</div>
                        </Grid>
                        <br />
                        <Grid item xs={12} >
                            <div style={styfC}>  {"----------------"}</div>
                        </Grid>
                    </Grid>
                    <Grid item xs={4} ></Grid>

                    <Grid item xs={4} style={{ textAlign: "reft", fontFamily: "Amiri-Regular", direction: "ltr" }}  >
                        <br />
                        <br />
                        <Grid item xs={12} >
                            <div style={styfC}>  {"توقيع البائع"}</div>
                        </Grid>
                        <br />
                        <Grid item xs={12} >
                            <div style={styfC}> {"----------------"}</div>
                        </Grid>
                    </Grid>


                </Grid>

            </Grid>

        </Grid>

    );
}
export default FooterNotes;

